import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { ArrayHelper } from '../../../../models/helpers/array-helper';
import { ConfirmDeleteModalComponent } from '../../../core/components/delete-modal/confirm-delete-modal-component';
export class DocumentationComponent {
    constructor(collectionService) {
        this.collectionService = collectionService;
        this.collectionsChange = new EventEmitter();
        this._newDocument = { id: '', photos: new Array() };
    }
    get collections() {
        return this._collections;
    }
    get newDocument() {
        return this._newDocument;
    }
    set collections(value) {
        if (value) {
            for (let photoCollectionDto of value) {
                photoCollectionDto.date = new Date(photoCollectionDto.date);
            }
        }
        this._collections = value;
        this.sortCollectionByDate();
    }
    ngOnInit() {
    }
    create() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._newDocument.plantingSiteId = this.siteId;
            this._newDocument.id = yield this.saveDocument(this._newDocument);
            this._newDocument = { id: '', photos: new Array() };
        });
    }
    saveDocument(document) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let id = yield this.collectionService.saveDocument(this.siteId, document);
            this._collections = [document, ...this._collections.filter(value => value.id != document.id)];
            this.sortCollectionByDate();
            this.collectionsChange.emit(this._collections);
            return id;
        });
    }
    displayConfirmDialogue(collection) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.confirmDelete.showAwait('');
            if (result) {
                let deletedId = yield this.collectionService.deletDocument(collection.id);
                this._collections = this._collections.filter(c => c.id != deletedId);
                this.collectionsChange.emit(this._collections);
            }
        });
    }
    sortCollectionByDate() {
        this._collections = ArrayHelper.sortBy(this._collections, false, coll => coll.date);
    }
}
